import { render, staticRenderFns } from "./PackagingTypesFile.vue?vue&type=template&id=5f5f7ff4&scoped=true"
import script from "./PackagingTypesFile.vue?vue&type=script&lang=js"
export * from "./PackagingTypesFile.vue?vue&type=script&lang=js"
import style0 from "./PackagingTypesFile.vue?vue&type=style&index=0&id=5f5f7ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f7ff4",
  null
  
)

export default component.exports